import { render, staticRenderFns } from "./OverrideForm.vue?vue&type=template&id=23265a44&"
import script from "./OverrideForm.vue?vue&type=script&lang=js&"
export * from "./OverrideForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports